var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('bo-page-title'),_c('BoUserForm',_vm._b({attrs:{"row":_vm.row,"is-account-setting":true},on:{"update:row":function($event){_vm.row=$event}}},'BoUserForm',_vm.passToSubComp,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }